module.exports = __webpack_public_path__ + "static/media/sample_templet_for_remarks.90d4982e.csv";